export default "__VITE_ASSET__DfvL3ZhK__"